import tableLives from './tableRelatedLives';

export default {
  title: 'Lives Enabled',
  attributeName: 'lives',
  getURL: 'scheduledLivesEnabled',
  itemName: 'name',
  itemId: 'id',
  sessionParams: [],
  tableConfig: tableLives,
};
